import { useState, useEffect, useContext, type ChangeEvent } from "react";
import { Box, TextField, Checkbox, Button } from "@mui/material";
import SnackbarCustom, {
  type SnackbarData,
} from "../../components/SnackBarCustom";
import PopoverCustom from "../../components/PopoverCustom";
import { TokenContext } from "../../TokenContext";
import { DisasterConditionRole } from "../../role";
import { useConfig } from "../../utils/ConfigContext";
import type { ConfigSettings } from "../../utils/ConfigContext";

const Environment = () => {
  const tokenContext = useContext(TokenContext);
  const user = tokenContext?.user;
  const { settings, updateConfig } = useConfig();
  const disasterConditionRole = DisasterConditionRole(
    user?.m_organization.m_role_id ?? 0
  );

  const [localSettings, setLocalSettings] = useState<ConfigSettings>(settings);

  useEffect(() => {
    setLocalSettings(settings);
  }, [settings]);

  const handleChangeTraining = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setLocalSettings((prevCheck) => ({
      ...prevCheck,
      training: newValue,
    }));
  };

  const handleChangeMaintenance = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setLocalSettings((prevCheck) => ({
      ...prevCheck,
      maintenance: newValue,
    }));
  };

  const handleChangeDryrun = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setLocalSettings((prevCheck) => ({
      ...prevCheck,
      dryrun: newValue,
    }));
  };

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalSettings((prevValue) => ({
      ...prevValue,
      from_name: newValue,
    }));
  };

  const [confirmPopoverOpen, setPopoverSplitOpen] = useState(false);
  const registerButtonClick = () => {
    setPopoverSplitOpen(true);
  };
  const confirmPopupClose = () => {
    setPopoverSplitOpen(false);
  };

  const putConfigData = async (isSuccess: boolean) => {
    if (!isSuccess) {
      console.log("何も行いません");
      return;
    }

    try {
      console.log("入力データ", localSettings);
      const status = await updateConfig(localSettings);
      console.log("レスポンスデータ:", status);
      setSnackBarstatus(status as SnackbarData);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("エラーが発生しました:", error);
    }
  };

  const [snackBarstatus, setSnackBarstatus] = useState<SnackbarData>();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
          maxWidth: "480px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:900px)": {
              flexDirection: "column",
              width: "100%",
              alignItems: "flex-start",
            },
          }}
        >
          <Box
            sx={{
              minWidth: "160px",
              padding: "9px 0",
              "@media screen and (max-width:900px)": {
                padding: "0",
              },
            }}
          >
            モード
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  name="checkboxTraining"
                  size="small"
                  checked={localSettings.training}
                  onChange={handleChangeTraining}
                  disabled={!disasterConditionRole.update}
                />
                訓練モード
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  name="checkboxMaintenance"
                  size="small"
                  checked={localSettings.maintenance}
                  onChange={handleChangeMaintenance}
                  disabled={!disasterConditionRole.update}
                />
                メンテナンスモード
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  name="checkboxMaintenance"
                  size="small"
                  checked={localSettings.dryrun}
                  onChange={handleChangeDryrun}
                  disabled={!disasterConditionRole.update}
                />
                テストモード
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:900px)": {
              flexDirection: "column",
              width: "100%",
              alignItems: "flex-start",
            },
          }}
        >
          <Box sx={{ minWidth: "160px" }}>メール送信元名称</Box>
          <TextField
            name="textFieldFromName"
            id="outlined-basic"
            variant="outlined"
            value={localSettings.from_name}
            onChange={handleChangeName}
            sx={{
              height: "40px",
              width: "100%",
              ".MuiInputBase-root": {
                height: "100%",
              },
              "#outlined-basic": {
                boxSizing: "border-box",
                height: "100%",
              },
            }}
            disabled={!disasterConditionRole.update}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            "@media screen and (max-width:600px)": {
              flexDirection: "column",
              alignItems: "center",
            },
          }}
        >
          <Button
            name="registrationButtonEnvironment"
            variant="contained"
            sx={{ width: "208px" }}
            onClick={() => registerButtonClick()}
            disabled={!disasterConditionRole.update}
          >
            登録
          </Button>
        </Box>
      </Box>
      <SnackbarCustom
        data={snackBarstatus}
        openStatus={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      />
      <PopoverCustom
        open={confirmPopoverOpen}
        onClose={confirmPopupClose}
        yesNo={putConfigData}
        title={"登録確認"}
        contents={"環境を登録してもよろしいですか？"}
      />
    </>
  );
};

export default Environment;
